import { useCallback } from 'react'
import {
  useCreateFlyoutMutation,
  useCreateHeroBannerMutation,
  useCreateSecondaryBannerMutation,
  type FlyoutPlacementInput,
  type HeroBannerPlacementInput,
  type SecondaryBannerPlacementInput,
} from 'domains/banners/api'

interface HeroBannerArgs {
  bannerData: HeroBannerPlacementInput
}

interface SecondaryBannerArgs {
  bannerData: SecondaryBannerPlacementInput
}

interface FlyoutArgs {
  bannerData: FlyoutPlacementInput
}

export const useCreateFlyout = () => {
  const [triggerMutation, { data, loading, error, called }] = useCreateFlyoutMutation()

  const createFlyout = useCallback(
    ({ bannerData }: FlyoutArgs) => {
      triggerMutation({
        variables: {
          data: bannerData,
        },
      })
    },
    [triggerMutation]
  )

  return {
    createFlyout,
    apiCalled: called,
    apiResult: data?.flyoutPlacementCreate?.flyoutPlacement,
    apiSuccess: Boolean(data),
    apiLoading: loading,
    apiError: error,
  }
}

export const useCreateHeroBanner = () => {
  const [triggerMutation, { data, loading, error, called }] = useCreateHeroBannerMutation()

  const createHeroBanner = useCallback(
    ({ bannerData }: HeroBannerArgs) => {
      triggerMutation({
        variables: {
          data: bannerData,
        },
      })
    },
    [triggerMutation]
  )

  return {
    createHeroBanner,
    apiCalled: called,
    apiResult: data?.heroBannerPlacementCreate?.heroBannerPlacement,
    apiSuccess: Boolean(data),
    apiLoading: loading,
    apiError: error,
  }
}

export const useCreateSecondaryBanner = () => {
  const [triggerMutation, { data, loading, error, called }] = useCreateSecondaryBannerMutation()

  const createSecondaryBanner = useCallback(
    ({ bannerData }: SecondaryBannerArgs) => {
      triggerMutation({
        variables: {
          data: bannerData,
        },
      })
    },
    [triggerMutation]
  )

  return {
    createSecondaryBanner,
    apiCalled: called,
    apiResult: data?.secondaryBannerPlacementCreate?.secondaryBannerPlacement,
    apiSuccess: Boolean(data),
    apiLoading: loading,
    apiError: error,
  }
}
